import { useQuery } from 'urql';
import { GetReadingSettingsQueryDocument } from '@/gql/client/graphql';

export function useReadingSettings() {
  const [{ data }] = useQuery({
    query: GetReadingSettingsQueryDocument,
  });
  return data?.readingSettings;
}
